import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { push } from 'connected-react-router';

import { Actions } from '../../actions';
import * as authActionCreators from '../../auth/action-creators';
import * as authActions from '../../auth/actions';
import { NoOp } from '../../ui/action-creators';
import AppState from '@webapp/store/state';

export const changeLoginSuccessEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, authActionCreators.ChangeLoginSuccess>(
      authActions.CHANGE_LOGIN_SUCCESS
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const { username, shouldVerify } = action;

      if (shouldVerify) {
        return push(`/user/verify?account=${encodeURIComponent(username)}`);
      }

      if (state.router.location.pathname !== '/user/general') {
        return push('/user/general');
      }

      return new NoOp();
    })
  );
